import React from "react";
import img1 from "../../../assets/wedding/images/shiv_logo_ws.svg";

const Footer = () => {
  return (
    <div>
      <section className="web-footer">
        <div className="container">
          <div className="row">
            <a href="https://shiv-worldwide.com/">
              <div className="col-md-12">
                <div>
                  Brought to you by
                </div>
                <img src={img1} className="d-footer-img" alt="images" />
              </div>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Footer;
